
export default {

    setCount(state, count) {
      state.count = count
    },

    setCurrentFacture (state, facture) {
      state.current = facture
    },

    setFactures (state, factures) {
      state.all = factures
      state.initialized = true
      state.page = 1
    },

    setNextFactures (state, factures) {    
      state.all = [ ...state.all, ...factures ]
      state.page++
    }
}